import { useSelector } from "react-redux";
import { IonLoading } from "@ionic/react";
import { selectUserFetchStatus } from "../../../store/userShow/selectors/selectUserFetchStatus";
export const LoadingSection: React.FC = () => {
  const fetchStatus = useSelector(selectUserFetchStatus);
  return (
    <>
      <IonLoading isOpen={fetchStatus === "pending"} message={"Cargando..."} />
    </>
  );
};
